import { HiddenWall, SceneObjects } from '@types'

export default function isHiddenWall(hiddenWall?: SceneObjects | string): hiddenWall is HiddenWall {
  if (typeof hiddenWall === 'string') return hiddenWall.startsWith('hiddenWall_')
  return !!hiddenWall && hiddenWall?.type === 'hiddenWall'
}
